import { faker } from '@faker-js/faker'
import { InvoiceDetailsResponse } from '../types'
import { getProviders } from './getProviders'
import { getCommodities } from './getCommodities'

export const generateInvoiceResponse = () => {
    const invoice: InvoiceDetailsResponse = {
        invoiceNo: faker.string.uuid(),
        accountNo: faker.string.uuid(),
        invoiceDocId: faker.number.int(),
        commodities: getCommodities(),
        providers: getProviders(),
        invoiceDate: Math.floor(faker.date.anytime().getTime() / 1000),
        submitDate: Math.floor(faker.date.anytime().getTime() / 1000),
        dueDate: Math.floor(faker.date.anytime().getTime() / 1000),
        invoiceTotal: {
            value: faker.number.int({
                min: 1000,
                max: 5000,
            }),
            unit: 'USD',
        },
        currentCharges: {
            value: faker.number.int({
                min: 1000,
                max: 5000,
            }),
            unit: 'USD',
        },
        balanceForward: {
            value: faker.number.int({
                min: 100,
                max: 500,
            }),
            unit: 'USD',
        },
        lateFee: {
            value: faker.number.int({
                min: 100,
                max: 500,
            }),
            unit: 'USD',
        },
    }

    return invoice
}
